import { createSelector } from '@reduxjs/toolkit';
import { fetchCatalogIdsBySearchTerm } from '@/redux/api/categoryCatalogCards';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_CATEGORY_CATALOG_IDS_FAIL = 'la/domain/items/LOAD_CATEGORY_CATALOG_IDS_FAIL';
export const LOAD_CATEGORY_CATALOG_IDS_SUCCESS = 'la/domain/items/LOAD_CATEGORY_CATALOG_IDS_SUCCESS';

interface DefaultState {
    categoryCatalogIds: [];
    title: string;
}

/* reducer */
const DEFAULT_STATE: DefaultState = {
    categoryCatalogIds: [],
    title: '',
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_CATEGORY_CATALOG_IDS_FAIL:
            return {
                ...state,
                categoryCatalogIds: [],
                title: '',
            };
        case LOAD_CATEGORY_CATALOG_IDS_SUCCESS:
            return {
                ...state,
                categoryCatalogIds: action.payload.ids,
                title: action.payload.title,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.categoryCatalogCards;

export const getCatalogIdsForCategory = createSelector(stateSelector, (state) => state.categoryCatalogIds || []);
export const getCategoryTitle = createSelector(stateSelector, (state) => state.title || []);

/* ACTION CREATORS */
export const fetchCatalogIds = (searchTerm: string) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const deployment = getDeployment(state);
    try {
        const response = await fetchCatalogIdsBySearchTerm({ deployment, searchTerm });
        let categoryTitle = searchTerm.split(' ');
        const uppercaseTitle = categoryTitle
            .map((word) => {
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(' ');
        dispatch({
            payload: {
                ids: response.payload,
                title: uppercaseTitle,
            },
            type: LOAD_CATEGORY_CATALOG_IDS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { searchTerm },
            payload: error,
            type: LOAD_CATEGORY_CATALOG_IDS_FAIL,
        });
    }
};
